import { render } from "./RollUp.vue?vue&type=template&id=7a72d4a1"
import script from "./RollUp.vue?vue&type=script&lang=js"
export * from "./RollUp.vue?vue&type=script&lang=js"

import "./RollUp.vue?vue&type=style&index=0&id=7a72d4a1&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__